// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bUHzQzkCExBKGnwI{display:block}.bUHzQzkCExBKGnwI .WuAHDfc08QD5R6Pe{display:block;text-align:center}.bUHzQzkCExBKGnwI .NBIVBX3N2Q4OjfrT{display:block}.DT58P9oP5lgJi3Bb{display:flex;justify-content:center;align-items:center;flex-shrink:0}.eo9LI_TJSV41ljBV{height:24px;width:24px}.eo9LI_TJSV41ljBV svg{height:18px}.wKdii4yTlMI5NKVe{height:16px;width:16px}.wKdii4yTlMI5NKVe svg{height:14px}.BXQRy16tbkKXyuDN{height:12px;width:12px}.BXQRy16tbkKXyuDN svg{height:12px}.o4g9FCfA2AIeWbyE{height:9px;width:9px}.o4g9FCfA2AIeWbyE svg{height:9px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cpIcon": `bUHzQzkCExBKGnwI`,
	"awesomeIcon": `WuAHDfc08QD5R6Pe`,
	"materialIcons": `NBIVBX3N2Q4OjfrT`,
	"iconContainer": `DT58P9oP5lgJi3Bb`,
	"regular": `eo9LI_TJSV41ljBV`,
	"small": `wKdii4yTlMI5NKVe`,
	"x-small": `BXQRy16tbkKXyuDN`,
	"xx-small": `o4g9FCfA2AIeWbyE`
};
export default ___CSS_LOADER_EXPORT___;
